/**
 * Shows the shop's email address that snippets/cfs-protect-email.liquid kept out of the page
 * source (anti-spam). The address arrives reversed in data-u / data-d and is put together here,
 * in the browser, as a normal mailto: link.
 * - <cfs-email>: the address as text (a link, unless it already sits inside one).
 * - a[data-cfs-mailto]: links that pointed at the address; their href goes back to mailto:.
 */
/** @param {HTMLElement} el */
function addressOf(el) {
  const reverse = (/** @type {string | undefined} */ text) => [...(text ?? '')].reverse().join('');
  const user = reverse(el.dataset.u);
  const domain = reverse(el.dataset.d);
  return user && domain ? `${user}@${domain}` : '';
}

class CfsEmail extends HTMLElement {
  connectedCallback() {
    const address = addressOf(this);
    if (!address) return;
    if (this.closest('a')) {
      this.textContent = address;
      return;
    }
    const link = document.createElement('a');
    link.href = `mailto:${address}`;
    link.textContent = address;
    this.replaceChildren(link);
  }
}

for (const link of /** @type {NodeListOf<HTMLAnchorElement>} */ (document.querySelectorAll('a[data-cfs-mailto]'))) {
  const address = addressOf(link);
  if (address) link.href = `mailto:${address}`;
}

if (!customElements.get('cfs-email')) customElements.define('cfs-email', CfsEmail);
